/* ==========================================================================
   SEFFAF HEADER — kaydirma durumu
   body.is-at-top   -> sayfa tam tepede
   body.is-scrolled -> sayfa kaydirilmis

   Kaynak: seffaf-header-kiti/assets/scroll-state.js (BlackBork / Release temasi)
   Dawn'a uyarlandi: rAF ile sinirlandi, sinif ilk boyamadan once ataniyor.
   ========================================================================== */
(function () {
  var EŞIK = 0; // 0 = 1px kaydirmada opaklasir

  function durumYaz() {
    var tepede = window.scrollY <= EŞIK;
    document.body.classList.toggle('is-at-top', tepede);
    document.body.classList.toggle('is-scrolled', !tepede);
  }

  // Tarayici sayfayi kaydirilmis konumda geri yukleyebilir (scroll restore),
  // bu yuzden dinleyiciden ONCE bir kez cagriliyor.
  if (document.body) {
    durumYaz();
  } else {
    document.addEventListener('DOMContentLoaded', durumYaz);
  }

  var bekliyor = false;
  window.addEventListener(
    'scroll',
    function () {
      if (bekliyor) return;
      bekliyor = true;
      requestAnimationFrame(function () {
        durumYaz();
        bekliyor = false;
      });
    },
    { passive: true }
  );
})();
